import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import { FieldErrors, FieldErrorsImpl, FieldValues } from 'react-hook-form';

interface ErrorBadgeProps<T extends FieldValues> {
  errors: FieldErrors<T>;
  formKey: string;
  shrink?: boolean;
}
const ErrorBadge = <T extends FieldValues>({
  errors,
  formKey,
  shrink = false,
}: ErrorBadgeProps<T>) => {
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  const setTransparent = hover ? { opacity: 0.1 } : undefined;
  const errorMessage = errors ? errors[formKey]?.message : null;

  return (
    <OverlayTrigger
      key={formKey}
      placement={'auto'}
      overlay={
        <Tooltip id={`tooltip-${formKey}`}>
          {typeof errorMessage === 'string'
            ? errorMessage
            : errorMessage
            ? String(errorMessage)
            : ''}
        </Tooltip>
      }
    >
      <div
        className="text-danger small text-truncate overflow-hidden error-badge-container mt-1"
        style={{ width: 'fit-content' }}
      >
        {typeof errorMessage === 'string' ? errorMessage : errorMessage ? String(errorMessage) : ''}
      </div>
    </OverlayTrigger>
  );
};

export default ErrorBadge;
